import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { color, spacing, fontSize } from '../theme'
import { getColorsFromOrder } from '../utils/getColorsFromOrder'
import { Avatar } from '../atoms/Avatar'

const EventWrapper = styled.div`
   background: ${color.white};
   padding: ${spacing.xs};
   display: flex;
   flex-flow: row wrap;
   justify-content: center;
   align-items: center;
   height: 44px;
   width: 100%;
   cursor: pointer;
   margin-bottom: 2px;
   overflow: hidden;

   ${props =>
      props.disabled
         ? `
         background: ${color.borderLight};
         border: 1px dashed ${color.border};
         border-left: 7px solid ${color.border};
         filter: grayscale(1);
   `
         : `
         background: ${props.currentColors.bg};
         border: none;
         border-left: 7px solid ${props.currentColors.color};
   `}
`
const Text = styled.span`
   font-size: ${fontSize.xs};
   padding: 1em 0;
   padding-left: ${spacing.s};
   color: ${color.text};
   white-space: break-spaces;
   margin-right: auto;
   min-width: 54px;

   ${props => (props.italic ? `font-style: italic;` : ``)};
   &:after {
      content: '';
      display: inline-block;
   }
`

export const CalendarEvent = ({ name, childOrder, dropOff, pickUp }) => {
   const disabled = !(dropOff && pickUp)
   const currentColors = getColorsFromOrder(childOrder)

   return (
      <EventWrapper disabled={disabled} currentColors={currentColors}>
         <Avatar name={name} childOrder={childOrder} size={'small'} />
         {dropOff && pickUp ? (
            <Text>
               {dropOff} / {pickUp}
            </Text>
         ) : (
            <Text italic>No booking</Text>
         )}
      </EventWrapper>
   )
}

CalendarEvent.propTypes = {
   /**
    * Child name both first and lastname
    */
   name: PropTypes.string.isRequired,
   /**
    * ChildOrder
    */
   childOrder: PropTypes.number.isRequired,
   /**
    * Start time : AM/PM
    */
   dropOff: PropTypes.string,
   /**
    * End time : AM/PM
    */
   pickUp: PropTypes.string
}

CalendarEvent.defaultProps = {
   name: 'First Lastname',
   dropOff: null,
   pickUp: null,
   childOrder: 1
}
